import { useCallback } from 'react';
import { loggingException } from 'app/libs/sentry';
import { isBrowser } from 'app/libs/environment';
import useSsrCookie from 'app/hook/common/useSsrCookie';

if (isBrowser) window.dataTalkSendJsonClientCount = window.dataTalkSendJsonClientCount ? window.dataTalkSendJsonClientCount : 0;

export default function useEnlog() {
	const { getCookie } = useSsrCookie();

	// 엔로그: dataset
	const propsDataset = useCallback((props) => {
		const findProps = Object.keys(props).filter((key) => key.indexOf('data-') > -1);
		const result = {};
		findProps.forEach((key) => {
			result[key] = props[key];
		});
		return result;
	}, []);
	// 엔로그: 로드체크
	const checkEnlogLoaded = () =>
		new Promise((resolve) => {
			if (typeof window.enlog?.sendJson === 'function') {
				resolve(true);
			}
			let count = 0;
			const loadEnlog = setInterval(() => {
				if (typeof window.enlog?.sendJson === 'function') {
					clearInterval(loadEnlog);
					resolve(true);
				}
				count += 1;
				if (count > 200) {
					clearInterval(loadEnlog);
					resolve(false);
					console.log('enlog: not working');
				}
			}, 50);
		});

	// 엔로그 : 사용되는 키 (dataTalkView, dataTalkViewSingle, dataTalkClick, dataTalkCustom)
	const enloggingJsonData = useCallback(async (param = {}) => {
		try {
			window.dataTalkSendJsonClientCount += 1;
			const data = param;
			data.client = {
				search: window.location.search,
				pathname: window.location.pathname,
				url: window.location.href,
				index: window.dataTalkSendJsonClientCount,
				referrer: document.referrer,
			};
			// console.log('(CLIENT)', 'client:', window.dataTalkSendJsonClientCount, data?.dataTalkView, window.location.pathname);
			const enlogLoaded = await checkEnlogLoaded();
			if (enlogLoaded) window.enlog.sendJson(data);
		} catch (err) {
			loggingException(err);
			console.log(err);
		}
	}, []);

	// 데이터토크 : hit 유입지표
	const enloggingDatatalkHit = useCallback(async (text = '') => {
		try {
			const enlogLoaded = await checkEnlogLoaded();
			if (enlogLoaded) window.enlog.dataTalk.setHit(text);
		} catch (err) {
			loggingException(err);
			console.log(err);
		}
	}, []);

	// 데이터토크 : view param 변경
	const enloggingSetViewParam = useCallback(async (param = {}) => {
		try {
			const enlogLoaded = await checkEnlogLoaded();
			if (enlogLoaded) window.enlog.dataTalk.setViewParam(param);
		} catch (err) {
			loggingException(err);
			console.log(err);
		}
	}, []);

	// 데이터토크 : 유입된 hit 정보 얻기
	const enloggingGetHit = useCallback(() => {
		const hitCookie = getCookie('_enlog_datatalk_hit');
		return hitCookie || window.enlogInitJson?.currenthit || '';
	}, [getCookie]);

	return {
		propsDataset,
		enloggingJsonData,
		checkEnlogLoaded,
		enloggingDatatalkHit,
		enloggingGetHit,
		enloggingSetViewParam,
	};
}
